<div class="gu-confirm">
  <div class="gu-confirm__icon">
    <mat-icon>warning</mat-icon>
  </div>
  <h3 class="gu-confirm__title">{{ data.title }}</h3>
  <p class="gu-confirm__message">{{ data.message }}</p>
  <div class="gu-confirm__actions">
    <button type="button" class="gu-btn gu-btn--ghost" (click)="cancel()">Cancelar</button>
    <button type="button" class="gu-btn gu-btn--danger" (click)="confirm()">
      {{ data.confirmLabel || 'Eliminar' }}
    </button>
  </div>
</div>
